import {ServiceNowKnowledgePageNode} from './api';

export const shouldFetchKnowledgePageDetail = ({
  selectedPageId,
  selectedPageFromTree,
  isCategoryPagesLoading,
  isNavMenuLoading,
}: {
  selectedPageId: string | null;
  selectedPageFromTree: ServiceNowKnowledgePageNode | null;
  isCategoryPagesLoading: boolean;
  isNavMenuLoading: boolean;
}): boolean => {
  if (!selectedPageId) {
    return false;
  }

  // Article URLs already identify the resource. Do not wait for discovery or
  // reuse a category body in place of the article endpoint's authorization.
  if (selectedPageId.startsWith('article-')) {
    return true;
  }

  if (selectedPageFromTree) {
    return selectedPageFromTree.node_type === 'article' && selectedPageFromTree.body == null;
  }

  return !isCategoryPagesLoading && !isNavMenuLoading;
};
